import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./Vendor.css";
import AlertModal from "../AlertModal/AlertModal";
import config from "../../config";
import useAuth from "../../Auth/useAuth";
import {FaSearch } from 'react-icons/fa';

const getVendorDataUrl = `${config.BASE_URL}/list-vendor`;
const insertVendorDataUrl = `${config.BASE_URL}/add-vendor`;
const updateVendorDataUrl = `${config.BASE_URL}/update-vendor`;
const deleteVendorDataUrl = `${config.BASE_URL}/delete-vendor`;

// approval request URLs
const createRequestUrl = `${config.BASE_URL}/create-request`;

const Vendor = () => {
  const [result, setResult] = useState([]);
  const [filteredResult, setFilteredResult] = useState([]);
  const [error, setError] = useState(false);
  const [errorpan, setErrorPan] = useState(false);
  const [errorgst, setErrorGST] = useState(false);
  // const [errorgstApplicable, setErrorGSTApplicable] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorMobile, setErrorMobile] = useState(false);
  const [errorBankName, setErrorBankName] = useState(false);
  const [errorBankAccount, setErrorBankAccount] = useState(false);
  const [errorIfscCode, setErrorIfscCode] = useState(false);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    recordId: null,
  });

  const [isLoading, setIsLoading] = useState(true);
  const { username, userProfile, setActiveModule } = useAuth();

  // Search state
  const [searchTerm, setSearchTerm] = useState("");

  
  // Add modal state
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const [formData, setFormData] = useState({
    companyName: "",
    companyOwner: "",
    tdsRate: 0,
    pan: "",
    gst: "",
    gstApplicable: "", // Changed default to 'No' string instead of boolean
    email: "",
    mobile: "",
    bankName: "",
    bankAccount: "",
    ifscCode: "",
  });

  const [submitMessage, setSubmitMessage] = useState("");
  const [editingId, setEditingId] = useState(null); // Track which row is being edited
  const [editingData, setEditingData] = useState({}); // Store data of the row being edited
  const editRef = useRef(null);

  // Approval request state
  const [approvalRequest, setApprovalRequest] = useState({
    module: "Vendor",
    username: username,
    profile: userProfile,
    action: "",
    args: {},
  });

  // Add modal state
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info'
  });

    // Modal handler functions
  const showModal = (title, message, type = 'info') => {
    setModalConfig({
      isOpen: true,
      title,
      message,
      type
    });
  };

  const closeModal = () => {
    setModalConfig(prev => ({ ...prev, isOpen: false }));
  };

  
  // Add modal handlers
  const openAddModal = () => {
    setIsAddModalOpen(true);
    // Reset form data when opening modal
    setFormData({
      companyName: "",
      companyOwner: "",
      tdsRate: 0,
      pan: "",
      gst: "",
      gstApplicable: "",
      email: "",
      mobile: "",
      bankName: "",
      bankAccount: "",
      ifscCode: "",
    });
    setSubmitMessage("");
    // Clear all errors
    setErrorPan("");
    setErrorGST("");
    setErrorEmail("");
    setErrorMobile("");
    setErrorBankName("");
    setErrorBankAccount("");
    setErrorIfscCode("");
  };

  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };

  // Search function
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    
    if (term.trim() === "") {
      setFilteredResult(result);
    } else {
      const filtered = result.filter(item => 
        item.companyName.toLowerCase().includes(term) || 
        item.companyOwner.toLowerCase().includes(term)
      );
      setFilteredResult(filtered);
    }
  };


  // Clear search
  const clearSearch = () => {
    setSearchTerm("");
    setFilteredResult(result);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    sessionStorage.setItem("actMod", "vendor");
    setActiveModule(sessionStorage.getItem("actMod"));
  }, [setActiveModule]);

  // Add this useEffect to update filtered results when result changes
  useEffect(() => {
    setFilteredResult(result);
    // If there's an active search term, re-apply the filter
    if (searchTerm.trim() !== "") {
      const filtered = result.filter(item => 
        (item.companyName && item.companyName.toLowerCase().includes(searchTerm.toLowerCase())) || 
        (item.companyOwner && item.companyOwner.toLowerCase().includes(searchTerm.toLowerCase()))
      );
      setFilteredResult(filtered);
    }
  }, [result]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      setError(false);
      const response = await axios.get(getVendorDataUrl, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response?.data && Array.isArray(response.data)) {
        console.log("Result Data:", response.data);
        setResult(response.data);
      } else {
        setResult([]);
      }
    } catch (error) {
      setError(true);
      console.error("Error while fetching vendors:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const capitalizeWords = (string) => {
    return string
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const capitalizeGSTPANIFSC = (string) => {
    return string
      .split(" ")
      .map((word) => word.toUpperCase())
      .join(" ");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let inputValue = value.trim();

    const alphanumericRegex = /^[a-zA-Z0-9]*$/;

    if (name === "pan" || name === "gst" || name === "ifscCode") {
      if (!alphanumericRegex.test(inputValue)) return;
    }

    if (name === "gst" || name === "pan" || name === "ifscCode") {
      inputValue = capitalizeGSTPANIFSC(value);
    } else if (
      name === "companyName" ||
      name === "companyOwner" ||
      name === "bankName"
    ) {
      inputValue = capitalizeWords(value);
    }

    if (name === "mobile" || name === "bankAccount") {
      inputValue = inputValue ? Number(inputValue) : null;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: inputValue,
    }));

    if (name === "pan" && inputValue.length === 10) {
      setErrorPan("");
    }
    if (name === "gst" && inputValue.length === 15) {
      setErrorGST("");
    }
    if (name === "email" && inputValue) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      setErrorEmail(!emailRegex.test(inputValue));
    }
    if (name === "mobile" && inputValue) {
      const mobileRegex = /^[0-9]{10}$/;
      setErrorMobile(!mobileRegex.test(inputValue.toString()));
    }
    if (name === "bankName" && inputValue) {
      const bankNameRegex = /^[a-zA-Z0-9\s]{1,40}$/;
      setErrorBankName(!bankNameRegex.test(inputValue));
    }
    if (name === "bankAccount" && inputValue) {
      const bankAccountRegex = /^[0-9]{9,18}$/;
      setErrorBankAccount(!bankAccountRegex.test(inputValue.toString()));
    }
    if (name === "ifscCode" && inputValue) {
      const ifscCodeRegex = /^[A-Z]{4}[0][A-Z0-9]{6}$/;
      setErrorIfscCode(!ifscCodeRegex.test(inputValue));
    }
    console.log(formData);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);

    let isValid = true;
    let panError = "";
    let gstError = "";
    let emailError = "";
    let mobileError = "";
    let bankNameError = "";
    let bankAccountError = "";
    let ifscError = "";

    if (formData.pan.length !== 0 && formData.pan.length !== 10) {
      panError = "PAN must be either empty or exactly 10 characters!";
      isValid = false;
    }

    if (formData.gst.length !== 0 && formData.gst.length !== 15) {
      gstError = "GST must be either empty or exactly 15 characters!";
      isValid = false;
    }

    if (
      formData.email &&
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
    ) {
      emailError = "Invalid email address!";
      isValid = false;
    }

    if (formData.mobile && !/^[0-9]{10}$/.test(formData.mobile)) {
      mobileError = "Mobile number must be exactly 10 digits or empty!";
      isValid = false;
    }

    if (formData.bankName && !/^[a-zA-Z0-9\s]{1,40}$/.test(formData.bankName)) {
      bankNameError = "Bank name must be at most 40 characters or empty!";
      isValid = false;
    }

    if (formData.bankAccount && !/^[0-9]{9,18}$/.test(formData.bankAccount)) {
      bankAccountError =
        "Bank account number must be between 9 and 18 digits or empty!";
      isValid = false;
    }

    if (
      formData.ifscCode &&
      !/^[A-Z]{4}[0][A-Z0-9]{6}$/.test(formData.ifscCode)
    ) {
      ifscError = "Invalid IFSC code!";
      isValid = false;
    }

    setErrorPan(panError);
    setErrorGST(gstError);
    setErrorEmail(emailError);
    setErrorMobile(mobileError);
    setErrorBankName(bankNameError);
    setErrorBankAccount(bankAccountError);
    setErrorIfscCode(ifscError);

    if (!isValid) return;

    if (userProfile === "admin") {
      console.log("Admin user, adding vendor directly.");
      try {
        const response = await axios.post(insertVendorDataUrl, formData, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log("response:::>>>>>", response.data);
        console.log("response status:::>>>>>", response.status);
        if (response.status === 200) {
          // setSubmitMessage(response.data.message);
          showModal("Success", response.data.message, "success");
          fetchData();
          closeAddModal(); // Close modal on success
        }

        setErrorPan("");
        setErrorGST("");
        setErrorEmail("");
        setErrorMobile("");
        setErrorBankName("");
        setErrorBankAccount("");
        setErrorIfscCode("");
      } catch (error) {
        if (error.response && error.response.status === 409) {
          setSubmitMessage(
            error.response.data.message || "Duplicate vendor entry detected."
          );
        } else {
          setSubmitMessage("Failed to submit vendor");
        }
      }
    } else {
      // Prepare approval request data
      const approvalPayload = {
        ...approvalRequest,
        action: "Add",
        args: formData,
      };
      console.log("Approval Payload:", approvalPayload);

      setApprovalRequest(approvalPayload);

      try {
        const response = await axios.post(
          createRequestUrl,
          { approvalRequest: approvalPayload },
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("response:", response.data);
        if (response.status === 200) {
          // setSubmitMessage("Vendor add - request sent for approval.");
          showModal("Success", "Vendor add - request sent for approval.", "success");
          fetchData();
          closeAddModal(); // Close modal on success
        }
      } catch (error) {
        console.error("Error submitting data:", error);
        // setSubmitMessage("Vendor add - Error! Trying to create duplicate request.");
        showModal("Error", "Vendor add - Error! Trying to create duplicate request.", "error");
      }
    }
    setFormData({
      companyName: "",
      companyOwner: "",
      tdsRate: "",
      pan: "",
      gst: "",
      gstApplicable: "",
      email: "",
      mobile: "",
      bankName: "",
      bankAccount: "",
      ifscCode: "",
    });
    setApprovalRequest((prev) => ({
      ...prev,
      action:"",
      args:{},
    }));
    setTimeout(() => {
      setSubmitMessage("");
    }, 1500);
  };

  const handleEdit = (vendor) => {
    setEditingId(vendor.id);
    setEditingData(vendor);
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;

    let inputValue = value.trim();

    const alphanumericRegex = /^[a-zA-Z0-9]*$/;

    if (name === "pan" || name === "gst" || name === "ifscCode") {
      if (!alphanumericRegex.test(inputValue)) return;
    }

    if (name === "gst" || name === "pan" || name === "ifscCode") {
      inputValue = capitalizeGSTPANIFSC(value);
    } else if (
      name === "companyName" ||
      name === "companyOwner" ||
      name === "bankName"
    ) {
      inputValue = capitalizeWords(value);
    }

    if (name === "mobile" || name === "bankAccount") {
      const numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters

      setEditingData((prevData) => ({
        ...prevData,
        [name]: numericValue, // Store only numbers
      }));

      return;
    }

    setEditingData((prevData) => ({
      ...prevData,
      [name]: inputValue,
    }));

    if (name === "pan" && inputValue.length === 10) {
      setErrorPan("");
    }
    if (name === "gst" && inputValue.length === 15) {
      setErrorGST("");
    }
    if (name === "email" && inputValue) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      setErrorEmail(!emailRegex.test(inputValue));
    }
    if (name === "mobile" && inputValue) {
      const mobileRegex = /^[0-9]{10}$/;
      setErrorMobile(!mobileRegex.test(inputValue.toString()));
    }
    if (name === "bankName" && inputValue) {
      const bankNameRegex = /^[a-zA-Z0-9\s]{1,40}$/;
      setErrorBankName(!bankNameRegex.test(inputValue));
    }
    if (name === "bankAccount" && inputValue) {
      const bankAccountRegex = /^[0-9]{9,18}$/;
      setErrorBankAccount(!bankAccountRegex.test(inputValue.toString()));
    }
    if (name === "ifscCode" && inputValue) {
      const ifscCodeRegex = /^[A-Z]{4}[0][A-Z0-9]{6}$/;
      setErrorIfscCode(!ifscCodeRegex.test(inputValue));
    }

    console.log("editingData", editingData);
  };

  const handleSave = async () => {
    console.log("Saving edited data:", editingData);
    if (userProfile === "admin") {
      try {
        const response = await axios.post(updateVendorDataUrl, editingData, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (response.status === 200) {
          console.log("Edit response:", response.data);
          showModal("Success", response.data.message, "success");
          fetchData(); // Refresh the data
        }
      } catch (error) {
        if (error.response && error.response.status === 409) {
            showModal("Error", error.response.data.message || "Duplicate vendor entry detected.", "error");
        } else {
          showModal("Error", "Failed to submit vendor. Please try again.", "error");
        }
      }
    } else {
      // Prepare approval request data
      const approvalPayload = {
        ...approvalRequest,
        action: "Update",
        args: editingData,
      };
      console.log("Approval Payload:", approvalPayload);

      setApprovalRequest(approvalPayload);

      try {
        const response = await axios.post(
          createRequestUrl,
          { approvalRequest: approvalPayload },
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          console.log(
            "Vendor updated - approval request created:",
            response.data
          );
          showModal("Success", "Vendor updated - approval request created.", "success");
        }
      } catch (error) {
        console.error(
          "Error while submitting request to update vendor:",
          error
        );
        showModal("Error", "Vendor update - Error! Trying to create duplicate request.", "error");
      }
    }
    setApprovalRequest((prev)=>({
      ...prev,
      action:"",
      args:{},
    }))
    setEditingId(null);
    setEditingData({});
  };

  const handleDelete = async (id) => {
    const deleteVendor = result.find((vendor) => vendor.id === id);
    console.log("Delete button clicked for ID:", id);
    setDeleteModal({
      isOpen: true,
      recordId: id,
      companyName: deleteVendor?.companyName || "",
    });
  };

  const confirmDelete = async () => {
    console.log("Admin user, deleting venodr directly.");
    if (userProfile === "admin") {
      try {
        const response = await axios.delete(
          `${deleteVendorDataUrl}/${deleteModal.recordId}`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // setResult((prev) => prev.filter((item) => item._id !== deleteModal.recordId));
        if (response.status === 200) {
          console.log("Vendor deleted successfully:", deleteModal.recordId);
          showModal("Success", "Vendor deleted successfully!", "success");
          fetchData(); // Refresh the data
        } else {
          showModal("Error", "Failed to delete Vendor.", "error");
        }
        // Show success notification (you could add a toast notification system here)
      } catch (error) {
        console.error("Error deleting record:", error);

        let errorMessage = "Error deleting record";
        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        showModal("Error", errorMessage, "error");
      }
    } else {
      // Prepare approval request data
      const vendor = result.find((vendor) => vendor.id === deleteModal.recordId);
      if (!vendor) {  
        console.error("Vendor to delete not found.");
        return;
      }
      const approvalPayload = {
        ...approvalRequest,
        action: "Delete",
        args: { id: deleteModal.recordId, vendorName: vendor.companyName, },
      };
      console.log("Approval Payload:", approvalPayload);

      setApprovalRequest(approvalPayload);

      try {
        const response = await axios.post(
          createRequestUrl,
          { approvalRequest: approvalPayload },
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          console.log("Vendor delete - approval request created:", response.data);
          showModal("Success", "Vendor delete - approval request created.", "success");
        }
      } catch (error) {
        console.error("Error while submitting request to delete vendor:", error);
        showModal("Error", "Vendor delete - Error! Trying to create duplicate request.", "error");
      }
    }
    setDeleteModal({ isOpen: false, recordId: null });
    setApprovalRequest((prev)=>({
      ...prev,
      action:"",
      args:{},
    }))
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const tableContainer = document.querySelector(".table-wrapper");
      const scrollBarThreshold = 15; // Threshold to consider as the scrollbar area (adjust as needed)

      // Check if the click is inside the table or not
      if (
        editRef.current &&
        !editRef.current.contains(event.target) &&
        !tableContainer.contains(event.target)
      ) {
        // Check if the event target is near the scrollbar area (either vertical or horizontal)
        const isHorizontalScrollbar =
          event.clientY > window.innerHeight - scrollBarThreshold;
        const isVerticalScrollbar =
          event.clientX > window.innerWidth - scrollBarThreshold;

        if (isHorizontalScrollbar || isVerticalScrollbar) {
          return; // Ignore the scrollbar area
        }

        console.log("Clicked outside the table, resetting edit mode.");
        setEditingId(null);
        setEditingData({});
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div id="vendor">
      <AlertModal
          isOpen={modalConfig.isOpen}
          onClose={closeModal}
          title={modalConfig.title}
          message={modalConfig.message}
          type={modalConfig.type}
      />
      {isLoading && (
        <div className="spinner-container">
          <div className="spinner"></div>
          <span>Loading Vendor...</span>
        </div>
      )}

       <div className="container-vendor">
        {!isLoading && (
          <>
            {/* Card Header with Add Button */}
            <div className="card-header">
              {/* <h2>Vendors</h2> */}
               <div className="vendor-search-container">
                      <FaSearch className="search-icon" />
                      <input
                        type="text"
                        className="search-input"
                        placeholder="Search by Vendor Name and Owner"
                        value={searchTerm}
                        onChange={handleSearch}
                      />
                      {searchTerm && (
                        <button className="clear-search" onClick={clearSearch}>
                          ×
                        </button>
                      )}
                    </div>
                    {searchTerm && (
                      <div className="search-results-info">
                        Found <strong>{filteredResult.length}</strong> result{filteredResult.length !== 1 ? 's' : ''} for "<strong>{searchTerm}</strong>"
                      </div>
                    )}
              <button className="add-button" onClick={openAddModal}>
                <span className="plus-icon">+</span>
                Add New Vendor
              </button>
            </div>

            {/* Add Vendor Modal */}
            {isAddModalOpen && (
              <div className="modal-overlay" onClick={closeAddModal}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-header">
                    <h3>Add New Vendor</h3>
                    <button className="close-button" onClick={closeAddModal}>×</button>
                  </div>
                  <form onSubmit={handleFormSubmit} autoComplete="off">
                    <div className="modal-body">
                      <div className="form-group">
                        <label htmlFor="companyName" className="required">Vendor Name:</label>
                        <div className="input-container">
                          <input
                            type="text"
                            id="companyName"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleInputChange}
                            placeholder="Enter vendor name"
                            required
                          />
                        </div>
                        <div className="input-helper">
                          <i>ℹ️</i> 3-40 characters long
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="companyOwner" className="required">Vendor Owner:</label>
                        <div className="input-container">
                          <input
                            type="text"
                            id="companyOwner"
                            name="companyOwner"
                            value={formData.companyOwner}
                            onChange={handleInputChange}
                            placeholder="Enter owner name"
                            required
                          />
                        </div>
                        <div className="input-helper">
                          <i>ℹ️</i> 3-40 characters long
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="tdsRate">TDS Rate (%):</label>
                        <div className="input-container">
                          <input
                            type="number"
                            id="tdsRate"
                            name="tdsRate"
                            step="0.01"
                            value={formData.tdsRate}
                            onChange={handleInputChange}
                            placeholder="Enter TDS rate"
                          />
                        </div>
                        <div className="input-helper">
                          <i>ℹ️</i> Between 0 and 100
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="pan">PAN:</label>
                        <div className="input-container">
                          <input
                            type="text"
                            id="pan"
                            name="pan"
                            value={formData.pan}
                            onChange={handleInputChange}
                            placeholder="Enter PAN number"
                          />
                        </div>
                        {errorpan && <p style={{ color: "red", margin: "5px 0 0 0", fontSize: "0.85rem" }}>{errorpan}</p>}
                        <div className="input-helper">
                          <i>ℹ️</i> Exactly 10 alphanumeric characters
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="gst">GST:</label>
                        <div className="input-container">
                          <input
                            type="text"
                            id="gst"
                            name="gst"
                            value={formData.gst}
                            onChange={handleInputChange}
                            placeholder="Enter GST number"
                          />
                        </div>
                        {errorgst && <p style={{ color: "red", margin: "5px 0 0 0", fontSize: "0.85rem" }}>{errorgst}</p>}
                        <div className="input-helper">
                          <i>ℹ️</i> Exactly 15 alphanumeric characters
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="gstApplicable">GST Applicable:</label>
                        <div className="input-container">
                          <select
                            id="gstApplicable"
                            name="gstApplicable"
                            value={formData.gstApplicable}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="email">Email:</label>
                        <div className="input-container">
                          <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="Enter email address"
                          />
                        </div>
                        {errorEmail && <p style={{ color: "red", margin: "5px 0 0 0", fontSize: "0.85rem" }}>{errorEmail}</p>}
                        <div className="input-helper">
                          <i>ℹ️</i> example@domain.com
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="mobile">Mobile:</label>
                        <div className="input-container">
                          <input
                            type="number"
                            id="mobile"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleInputChange}
                            placeholder="Enter mobile number"
                          />
                        </div>
                        {errorMobile && <p style={{ color: "red", margin: "5px 0 0 0", fontSize: "0.85rem" }}>{errorMobile}</p>}
                        <div className="input-helper">
                          <i>ℹ️</i> Exactly 10 digits
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="bankName">Bank Name:</label>
                        <div className="input-container">
                          <input
                            type="text"
                            id="bankName"
                            name="bankName"
                            value={formData.bankName}
                            onChange={handleInputChange}
                            placeholder="Enter bank name"
                          />
                        </div>
                        {errorBankName && <p style={{ color: "red", margin: "5px 0 0 0", fontSize: "0.85rem" }}>{errorBankName}</p>}
                        <div className="input-helper">
                          <i>ℹ️</i> 1-40 characters long
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="bankAccount">Bank Account Number:</label>
                        <div className="input-container">
                          <input
                            type="number"
                            id="bankAccount"
                            name="bankAccount"
                            value={formData.bankAccount}
                            onChange={handleInputChange}
                            placeholder="Enter account number"
                          />
                        </div>
                        {errorBankAccount && <p style={{ color: "red", margin: "5px 0 0 0", fontSize: "0.85rem" }}>{errorBankAccount}</p>}
                        <div className="input-helper">
                          <i>ℹ️</i> 9-18 digits
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="ifscCode">IFSC Code:</label>
                        <div className="input-container">
                          <input
                            type="text"
                            id="ifscCode"
                            name="ifscCode"
                            value={formData.ifscCode}
                            onChange={handleInputChange}
                            placeholder="Enter IFSC code"
                          />
                        </div>
                        {errorIfscCode && <p style={{ color: "red", margin: "5px 0 0 0", fontSize: "0.85rem" }}>{errorIfscCode}</p>}
                        <div className="input-helper">
                          <i>ℹ️</i> Format: ABCD0123456
                        </div>
                      </div>

                      {submitMessage && <p className="submit-message">{submitMessage}</p>}
                    </div>
                    
                    <div className="modal-footer">
                      <button type="button" className="cancel-button" onClick={closeAddModal}>
                        Cancel
                      </button>
                      <button type="submit" className="submit-button">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
            </>
        )}

          {/* Search Bar Section */}
                {/* {!isLoading && (
                  <div className="search-section">
                    <div className="vendor-search-container">
                      <FaSearch className="search-icon" />
                      <input
                        type="text"
                        className="search-input"
                        placeholder="Search by Vendor Name and Owner"
                        value={searchTerm}
                        onChange={handleSearch}
                      />
                      {searchTerm && (
                        <button className="clear-search" onClick={clearSearch}>
                          ×
                        </button>
                      )}
                    </div>
                    {searchTerm && (
                      <div className="search-results-info">
                        Found <strong>{filteredResult.length}</strong> result{filteredResult.length !== 1 ? 's' : ''} for "<strong>{searchTerm}</strong>"
                      </div>
                    )}
                  </div>
                )} */}

        
        <div className="table-wrapper" id="results">
          {isLoading && (
            <div className="modal-spinner-overlay">
              <div className="spinner"></div>
              <span>Loading vendor data...</span>
            </div>
          )}
          {!isLoading && (
            <div className="scrollable-table">
              <table id="resultsTable">
                <thead>
                  <tr>
                    <th>Index</th>
                    <th>Vendor Name</th>
                    <th>Vendor Owner</th>
                    <th>TDS Rate (%)</th>
                    <th>GST</th>
                    <th>GST Applicable</th>
                    <th>PAN</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Bank Name</th>
                    <th>Bank Account Number</th>
                    <th>IFSC Code</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {error ? (
                    <tr>
                      <td colSpan="14">
                        Error fetching data. Please try again later.
                      </td>
                    </tr>
                  ) : filteredResult.length === 0 ? (
                    <tr>
                      <td colSpan="14" className="empty-row">
                        No data available.
                      </td>
                    </tr>
                  ) : (
                    filteredResult.map((vendor) => (
                      <tr
                        key={vendor.id}
                        ref={editingId === vendor.id ? editRef : null}
                      >
                        <td>{vendor.index}</td>
                        <td>
                          {editingId === vendor.id ? (
                            <input
                              type="text"
                              name="companyName"
                              value={editingData.companyName}
                              onChange={handleEditInputChange}
                            />
                          ) : (
                            vendor.companyName
                          )}
                        </td>
                        <td>
                          {editingId === vendor.id ? (
                            <input
                              type="text"
                              name="companyOwner"
                              value={editingData.companyOwner}
                              onChange={handleEditInputChange}
                            />
                          ) : (
                            vendor.companyOwner
                          )}
                        </td>
                        <td>
                          {editingId === vendor.id ? (
                            <input
                              type="number"
                              name="tdsRate"
                              value={editingData.tdsRate}
                              onChange={handleEditInputChange}
                            />
                          ) : (
                            vendor.tdsRate || 0
                          )}
                        </td>
                        <td>
                          {editingId === vendor.id ? (
                            <input
                              type="text"
                              name="gst"
                              value={editingData.gst}
                              onChange={handleEditInputChange}
                            />
                          ) : (
                            vendor.gst
                          )}
                        </td>
                        <td>
                          {editingId === vendor.id ? (
                            <select
                              name="gstApplicable"
                              value={editingData.gstApplicable}
                              onChange={handleEditInputChange}
                            >
                              <option value="">Select</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          ) : (
                            vendor.gstApplicable
                          )}
                        </td>
                        <td>
                          {editingId === vendor.id ? (
                            <input
                              type="text"
                              name="pan"
                              value={editingData.pan}
                              onChange={handleEditInputChange}
                            />
                          ) : (
                            vendor.pan
                          )}
                        </td>
                        <td>
                          {editingId === vendor.id ? (
                            <input
                              type="email"
                              name="email"
                              value={editingData.email}
                              onChange={handleEditInputChange}
                            />
                          ) : (
                            vendor.email
                          )}
                        </td>
                        <td>
                          {editingId === vendor.id ? (
                            <input
                              type="text"
                              name="mobile"
                              value={editingData.mobile}
                              onChange={handleEditInputChange}
                            />
                          ) : (
                            vendor.mobile
                          )}
                        </td>

                        <td>
                          {editingId === vendor.id ? (
                            <input
                              type="text"
                              name="bankName"
                              value={editingData.bankName}
                              onChange={handleEditInputChange}
                            />
                          ) : (
                            vendor.bankName
                          )}
                        </td>

                        <td>
                          {editingId === vendor.id ? (
                            <input
                              type="text"
                              name="bankAccount"
                              value={editingData.bankAccount}
                              onChange={handleEditInputChange}
                            />
                          ) : (
                            vendor.bankAccount
                          )}
                        </td>

                        <td>
                          {editingId === vendor.id ? (
                            <input
                              type="text"
                              name="ifscCode"
                              value={editingData.ifscCode}
                              onChange={handleEditInputChange}
                            />
                          ) : (
                            vendor.ifscCode
                          )}
                        </td>

                        <td>
                          {editingId === vendor.id ? (
                            <button className="save-btn" onClick={handleSave}>
                              Save
                            </button>
                          ) : (
                            <button
                              className="edit-btn"
                              onClick={() => handleEdit(vendor)}
                            >
                              Edit
                            </button>
                          )}
                        </td>
                        {/* {
                                            (userProfile !== 'loadingManager' && userProfile !== 'unloadingManager')
                                            && */}
                        <td>
                          <button
                            className="delete-btn"
                            onClick={() => handleDelete(vendor.id)} // Open the modal with the ID
                          >
                            Delete
                          </button>
                        </td>
                        {/* } */}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
          {deleteModal.isOpen && (
            <div className="delete-modal-overlay">
              <div className="delete-modal">
                <div className="delete-modal-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="54"
                    height="54"
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                      fill="#ff4757"
                      d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586z"
                    />
                  </svg>
                </div>
                <h3>Confirm Delete</h3>
                <p>
                  Are you sure you want to delete this Vendor:
                  <span className="trip-id-highlight">
                    {" "}
                    {deleteModal.companyName}
                  </span>
                  ?
                </p>
                <p className="warning-text">This action cannot be undone.</p>
                <div className="delete-modal-buttons">
                  <button
                    className="cancel-btn"
                    onClick={() =>
                      setDeleteModal({ isOpen: false, recordId: null })
                    }
                  >
                    Cancel
                  </button>
                  <button
                    className="confirm-delete-btn"
                    onClick={confirmDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Vendor;